import styled from "styled-components";
import MenuItems from "./MenuItems";

const StyledDropdown = styled.ul`
  position: absolute;
  //left: ${(props) => (props.$depthLevel === 0 ? "1rem" : "100%")};
  top: ${(props) => (props.$depthLevel === 1 ? "2rem" : "auto")};

  margin-left: ${(props) =>
    props.$depthLevel === 2 ? "80px" : "0px"}; // Adjust margin for level 2

  box-shadow: var(--shadow-md);
  font-size: 0.8em;
  z-index: 9999;
  min-width: 20rem;
  padding: 0.5rem 0;
  list-style: none;
  background-color: var(--backdrop-color);
  backdrop-filter: blur(4px);
  border-radius: 0.5rem;
  display: ${(props) => (props.$dropdown ? "block" : "none")};
`;

const StyledMenuItem = styled.li`
  position: relative;
  font-size: 1.7em;

  a,
  button {
    display: block;
    font-size: inherit;
    color: inherit;
    text-decoration: none;
    text-align: left;
    padding: 0.7rem 1rem;

    &:hover {
      background-color: var(--color-grey-200);
      color: var(--color-grey-50);
    }
  }

  button {
    color: inherit;
    font-size: inherit;
    border: none;
    background-color: transparent;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
  }
`;

function Dropdown({ submenus, dropdown, depthLevel }) {
  return (
    <StyledDropdown $dropdown={dropdown} $depthLevel={depthLevel}>
      {submenus.map((submenu, index) => (
        <MenuItems key={index} items={submenu} depthLevel={depthLevel} />
      ))}
    </StyledDropdown>
  );
}

export default Dropdown;
